'use strict';

exports.__esModule = true;

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _Perimeter = require('../Perimeter');

var _Perimeter2 = _interopRequireDefault(_Perimeter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isPerimeter = function isPerimeter(obj) {
  return (0, _isObject2.default)(obj) && obj instanceof _Perimeter2.default;
};

exports.default = isPerimeter;


//////////////////
// WEBPACK FOOTER
// ./~/kindergarten/lib/utils/isPerimeter.js
// module id = ba7H
// module chunks = 0